import { DatePicker, Modal, Select, Spin } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import Lottie from 'lottie-react';
import successLottie from '../../../../utils/Lottie/success.json';
import failedLottie from '../../../../utils/Lottie/failed.json';
import pendingLottie from '../../../../utils/Lottie/pending.json';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  dateFormat,
  LedgerTransactionPaymentEnum,
  paymentStatusEnum,
  SupplierModuleTypeEnum,
} from '../../../../utils/settings';
import { getLedgerTransAction } from '../../action/util_action';
import LedgerTransaction from './Component/LedgerTransaction';

import './ledgerBalance.less';
import { currencyNumber } from '../SchemeBenefit/goldenAgePlanListing';
import { Box } from '@mui/material';
import { getCompanySuppliersAction } from '../../../../v2/BCMOrder/Action';
import { toast } from 'react-toastify';

const { RangePicker } = DatePicker;
const styles = {
  successStyle: {
    color: 'rgb(0, 207, 51)',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    fontFamily: 'sans-serif',
    display: 'flex',
    justifyContent: 'center',
  },
  failedStyle: {
    color: 'rgb(211, 46, 46)',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    fontFamily: 'sans-serif',
    display: 'flex',
    justifyContent: 'center',
  },
  pendingStyle: {
    color: 'rgb(247, 201, 66)',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    fontFamily: 'sans-serif',
    display: 'flex',
    justifyContent: 'center',
  },
};
export default function PaymentHistory() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [obj, setObj] = useState({});
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ledgerstrans, setLedgerstrans] = useState({});
  const [pageNumber, setPageNumber] = useState(1);

  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [transactionsStatus, setTransactionsStatus] = useState('COMPLETED');

  // Month Filter
  const [monthFilter, setMonthFilter] = useState({ end: null, start: null });
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [isFailedModalVisible, setIsFailedModalVisible] = useState(false);
  const [isPendingModalVisible, setIsPendingModalVisible] = useState(false);

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const status = queryParameters.get('status');
    switch (status) {
      case paymentStatusEnum.SUCCESS:
        setIsSuccessModalVisible(true);
        break;
      case paymentStatusEnum.FAILED:
        setIsFailedModalVisible(true);
        break;
      case paymentStatusEnum.PENDING:
        setIsPendingModalVisible(true);
        break;
      default:
        break;
    }
  }, []);

  const getLedgertrans = async () => {
    setLoading(true);
    const { data, error, message } = await getLedgerTransAction({
      seller_id: Number(obj.seller_id),
      page: pageNumber,
      isCredit: true,
      monthFilter,
      status: transactionsStatus,
    });
    setLoading(false);

    if (!error) {
      setLedgerstrans(data);
    } else {
      return toast.error(message);
    }
  };

  useEffect(() => {
    if (obj.seller_id) {
      getLedgertrans();
    }
  }, [obj.seller_id, pageNumber, monthFilter, transactionsStatus]);

  const getAllCompanies = async () => {
    setLoading(true);
    const { error, data, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.payment_history_enabled,
    );
    setLoading(false);

    if (!error) {
      const temp = data
        .map((item) => {
          return item.suppliers_list;
        })
        .flat();
      if (temp.length > 0) {
        setObj({ ...obj, seller_id: temp[0].id });
      }
      setCompanies(
        temp.map((item) => {
          return {
            label: item.name,
            value: item.id,
            key: item.id,
          };
        }),
      );
    }
  };

  useEffect(() => {
    getAllCompanies();
  }, []);

  const pageIncrementHandler = () => {
    if (ledgerstrans?.ledger_transactions?.length === 10) {
      setPageNumber((prev) => prev + 1);
    }
  };

  const pageDecrementHandler = () => {
    if (pageNumber > 1) {
      setPageNumber((prev) => prev - 1);
    }
  };

  const onRangeChange = (dates, dateStrings) => {
    if (dates && dateStrings) {
      setMonthFilter({ end: dateStrings[1], start: dateStrings[0] });
      if (dateStrings[1] && dateStrings[0]) setDatePickerOpen(false);
    }
  };

  const rangePresets = [
    {
      label: 'Last 7 Days',
      value: [
        moment().subtract(7, 'days').format(dateFormat),
        moment().format(dateFormat),
      ],
    },
    {
      label: 'Last 30 Days',
      value: [
        moment().subtract(30, 'days').format(dateFormat),
        moment().format(dateFormat),
      ],
    },
    {
      label: 'Last 90 Days',
      value: [
        moment().subtract(90, 'days').format(dateFormat),
        moment().format(dateFormat),
      ],
    },
  ];

  const setPresetsDate = (index) => {
    const date = rangePresets[index].value;
    setMonthFilter({ start: date[0], end: date[1] });
    setDatePickerOpen(false);
  };

  const dateOptionsPresets = (
    <div style={{ display: 'flex' }}>
      {rangePresets.map((item, i) => (
        <h4
          onClick={() => {
            setPresetsDate(i);
          }}
          style={{ marginRight: '10px', cursor: 'pointer', color: '#f49d3f' }}
        >
          {item.label}
        </h4>
      ))}
    </div>
  );

  const filterSelectComponent = (
    <Select
      style={{ width: '12rem', marginRight: '10px' }}
      optionFilterProp='children'
      placeholder={'Status'}
      defaultValue={'COMPLETED'}
      onChange={(e) => setTransactionsStatus(e)}
    >
      {LedgerTransactionPaymentEnum &&
        LedgerTransactionPaymentEnum.map((item, i) => {
          return (
            <Select.Option
              value={item.name}
              key={`${item.name} + ${i}`}
            >
              {item.name}
            </Select.Option>
          );
        })}
    </Select>
  );

  const companiesFilter = (
    <Select
      style={{ width: '12rem', marginRight: '10px' }}
      optionFilterProp='children'
      placeholder={t('addInvoice.searchCompany')}
      onChange={(e) => {
        setObj({ ...obj, seller_id: e });
      }}
      options={companies}
      value={obj.seller_id}
      defaultValue={companies[0]}
    />
  );

  const paymentSuccessModal = (
    <>
      <Modal
        onCancel={() => setIsSuccessModalVisible(false)}
        open={isSuccessModalVisible}
        footer={null}
      >
        <Lottie
          animationData={successLottie}
          loop={false}
        />
        <span style={styles.successStyle}>Payment Successfull</span>
      </Modal>
    </>
  );
  const paymentFailedModal = (
    <>
      <Modal
        onCancel={() => setIsFailedModalVisible(false)}
        open={isFailedModalVisible}
        footer={null}
      >
        <Lottie
          animationData={failedLottie}
          loop={false}
        />
        <span style={styles.failedStyle}>Payment Failed</span>
      </Modal>
    </>
  );
  const paymentPendingModal = (
    <>
      <Modal
        onCancel={() => setIsPendingModalVisible(false)}
        open={isPendingModalVisible}
        footer={null}
      >
        <Lottie
          animationData={pendingLottie}
          loop={false}
        />
        <span style={styles.pendingStyle}>Payment Pending</span>
      </Modal>
    </>
  );

  return (
    <Box
      sx={{
        padding: 2,
        overflowY: 'scroll',
        backgroundColor: 'rgba(217, 217, 217, .1)',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {paymentSuccessModal}
      {paymentFailedModal}
      {paymentPendingModal}

      <div className='payment_subcontainer'>
        <div
          className='payment_shadow'
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div className='payment_title'>
            <h2 className='payment_title-text'>Payment History</h2>
          </div>

          <div
            className='topButtons'
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
            }}
          >
            {companiesFilter}
            {filterSelectComponent}
            <RangePicker
              onOpenChange={() => setDatePickerOpen(!datePickerOpen)}
              renderExtraFooter={() => dateOptionsPresets}
              onChange={(dates, dateStrings) => {
                onRangeChange(dates, dateStrings);
              }}
              open={datePickerOpen}
            />
          </div>

          <div style={{ width: '100%' }}>
            <Spin spinning={loading}>
              <LedgerTransaction
                transactions={ledgerstrans}
                showOpeningBalance={false}
              />
              {ledgerstrans &&
                ledgerstrans?.ledger_transactions?.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      backgroundColor: '#f1f5f9',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <h3 style={{ color: '#744a1d', marginRight: '2rem' }}>
                      Total Amount :{' '}
                      {currencyNumber(
                        Number(
                          ledgerstrans?.ledger_transactions?.reduce(
                            (acc, item) => acc + item.amount,
                            0,
                          ),
                        ),
                      )}
                    </h3>
                  </div>
                )}
            </Spin>
          </div>

          <div
            className='orders__logo'
            style={{
              width: '100%',
            }}
          >
            {!loading && (
              <div className={'paginationContainer'}>
                <div
                  className={'nextBtn'}
                  style={{ borderRadius: '5px', cursor: 'pointer' }}
                  onClick={() => {
                    pageDecrementHandler();
                  }}
                >
                  {t('prev')}
                </div>
                <div
                  className={'pageNumber'}
                  style={{ margin: '0px 7px' }}
                >
                  {pageNumber}
                </div>
                <div
                  className={'nextBtn'}
                  style={{ borderRadius: '5px', cursor: 'pointer' }}
                  onClick={() => {
                    pageIncrementHandler();
                  }}
                >
                  {t('next')}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Box>
  );
}
